import { ChipCounterList } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { TestStatusGroup } from 'shared/types';
import { CoverageTableRow } from '../types';

const testNamesRenderer = ({ coverage }: CoverageTableRow) => {
  const coverageKeys = Object.keys(coverage) as Array<
    keyof CoverageTableRow['coverage']
  >;

  const allTestNames: string[] = [];

  coverageKeys.forEach((coverageKey) => {
    if (typeof coverage[coverageKey] !== 'number') {
      Object.keys(coverage[coverageKey] || {}).forEach((statusKey) => {
        const testsForStatus =
          typeof coverage[coverageKey] === 'object'
            ? (coverage[coverageKey] as TestStatusGroup)?.[
                statusKey as keyof TestStatusGroup
              ] || []
            : [];

        if (testsForStatus?.length) allTestNames.push(...testsForStatus);
      });
    }
  });

  const uniqueTestNames = Array.from(new Set(allTestNames));

  if (uniqueTestNames.length === 0) {
    return <Typography>-</Typography>;
  }

  return <ChipCounterList items={uniqueTestNames} />;
};

export default testNamesRenderer;
